import React from 'react';
import { Link } from 'react-router-dom';

const FocusOrganiza = () => {
  const services = [
    {
      title: 'Organização de Processos',
      description: 'Mapeamento e otimização de processos empresariais para maior eficiência operacional.',
      icon: '📋',
      features: ['Mapeamento de processos', 'Identificação de gargalos', 'Padronização de atividades']
    },
    {
      title: 'Gestão Documental',
      description: 'Organização e digitalização de documentos para facilitar o acesso e controle.',
      icon: '📁',
      features: ['Digitalização de arquivos', 'Sistema de classificação', 'Controle de versões']
    },
    {
      title: 'Layout e Ergonomia',
      description: 'Otimização do espaço físico e ergonomia para melhorar a produtividade.',
      icon: '🏢',
      features: ['Análise ergonômica', 'Otimização de layout', 'Melhoria do ambiente']
    },
    {
      title: 'Gestão de Tempo',
      description: 'Técnicas e ferramentas para otimização do tempo e aumento da produtividade.',
      icon: '⏰',
      features: ['Planejamento de atividades', 'Priorização de tarefas', 'Controle de prazos']
    }
  ];

  const benefits = [
    { icon: '📈', title: 'Aumento de Produtividade', description: 'Até 50% de melhoria na eficiência operacional' },
    { icon: '💰', title: 'Redução de Custos', description: 'Economia significativa em recursos e tempo' },
    { icon: '🎯', title: 'Foco nos Resultados', description: 'Maior clareza nos objetivos e metas' },
    { icon: '😊', title: 'Bem-estar da Equipe', description: 'Ambiente mais organizado e produtivo' }
  ];

  return (
    <div className="pt-32"> {/* Espaço para header fixo */}
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-focus-orange to-red-600 text-white py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Focus Organiza
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-red-100">
              Transforme o caos em ordem. Organizamos sua empresa para máxima eficiência e produtividade.
            </p>
            <Link
              to="/#contato"
              className="bg-white text-focus-orange hover:bg-gray-100 px-8 py-4 rounded-lg text-lg font-semibold transition-colors inline-block"
            >
              Organize sua Empresa
            </Link>
          </div>
        </div>
      </section>

      {/* Sobre o Serviço */}
      <section className="py-20 bg-focus-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-focus-blue mb-6">
                A Organização que sua Empresa Precisa
              </h2>
              <p className="text-lg text-gray-600 mb-6">
                O Focus Organiza é um serviço especializado em transformar ambientes desorganizados 
                em espaços produtivos e eficientes. Nossa metodologia comprovada ajuda empresas a 
                otimizar processos, organizar documentos e melhorar o fluxo de trabalho.
              </p>
              <p className="text-lg text-gray-600 mb-8">
                Com nossa experiência, identificamos rapidamente os pontos de melhoria e implementamos 
                soluções práticas que geram resultados imediatos e duradouros.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <div className="bg-focus-blue text-white px-6 py-3 rounded-lg text-center">
                  <div className="text-2xl font-bold">300+</div>
                  <div className="text-sm">Empresas Organizadas</div>
                </div>
                <div className="bg-focus-orange text-white px-6 py-3 rounded-lg text-center">
                  <div className="text-2xl font-bold">95%</div>
                  <div className="text-sm">Satisfação dos Clientes</div>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-lg p-8">
              <h3 className="text-2xl font-bold text-focus-blue mb-6">Principais Problemas que Resolvemos</h3>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <span className="text-focus-orange text-xl mr-3">❌</span>
                  <span className="text-gray-700">Processos desorganizados e ineficientes</span>
                </li>
                <li className="flex items-start">
                  <span className="text-focus-orange text-xl mr-3">❌</span>
                  <span className="text-gray-700">Documentos perdidos ou mal arquivados</span>
                </li>
                <li className="flex items-start">
                  <span className="text-focus-orange text-xl mr-3">❌</span>
                  <span className="text-gray-700">Espaços físicos mal aproveitados</span>
                </li>
                <li className="flex items-start">
                  <span className="text-focus-orange text-xl mr-3">❌</span>
                  <span className="text-gray-700">Perda de tempo procurando informações</span>
                </li>
                <li className="flex items-start">
                  <span className="text-focus-orange text-xl mr-3">❌</span>
                  <span className="text-gray-700">Falta de padronização nas atividades</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Serviços Oferecidos */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-focus-blue mb-4">
              Nossos Serviços de Organização
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Oferecemos soluções completas para organizar todos os aspectos da sua empresa
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-focus-white rounded-lg shadow-lg p-8 hover:shadow-xl transition-shadow border border-gray-100"
              >
                <div className="flex items-start mb-6">
                  <div className="bg-focus-orange w-16 h-16 rounded-full flex items-center justify-center text-2xl mr-4 flex-shrink-0">
                    {service.icon}
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-focus-blue mb-2">
                      {service.title}
                    </h3>
                    <p className="text-gray-600 mb-4">
                      {service.description}
                    </p>
                  </div>
                </div>
                <div className="border-t border-gray-200 pt-4">
                  <h4 className="font-semibold text-focus-blue mb-2">Inclui:</h4>
                  <ul className="space-y-1">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center text-sm text-gray-600">
                        <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefícios */}
      <section className="py-20 bg-focus-pink">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-focus-blue mb-4">
              Benefícios da Organização Empresarial
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Veja como a organização pode transformar sua empresa
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-lg p-6 text-center hover:shadow-xl transition-shadow"
              >
                <div className="text-4xl mb-4">{benefit.icon}</div>
                <h3 className="text-lg font-semibold text-focus-blue mb-2">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 text-sm">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Processo de Trabalho */}
      <section className="py-20 bg-focus-blue text-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Como Trabalhamos
            </h2>
            <p className="text-lg text-blue-100 max-w-2xl mx-auto">
              Nosso processo estruturado garante resultados efetivos e duradouros
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
            <div className="text-center">
              <div className="bg-focus-orange w-16 h-16 rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">
                1
              </div>
              <h3 className="text-lg font-semibold mb-2">Diagnóstico</h3>
              <p className="text-blue-100 text-sm">Avaliação completa da situação atual</p>
            </div>
            <div className="text-center">
              <div className="bg-focus-orange w-16 h-16 rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">
                2
              </div>
              <h3 className="text-lg font-semibold mb-2">Planejamento</h3>
              <p className="text-blue-100 text-sm">Criação do plano de organização</p>
            </div>
            <div className="text-center">
              <div className="bg-focus-orange w-16 h-16 rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">
                3
              </div>
              <h3 className="text-lg font-semibold mb-2">Implementação</h3>
              <p className="text-blue-100 text-sm">Execução das melhorias</p>
            </div>
            <div className="text-center">
              <div className="bg-focus-orange w-16 h-16 rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">
                4
              </div>
              <h3 className="text-lg font-semibold mb-2">Treinamento</h3>
              <p className="text-blue-100 text-sm">Capacitação da equipe</p>
            </div>
            <div className="text-center">
              <div className="bg-focus-orange w-16 h-16 rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">
                5
              </div>
              <h3 className="text-lg font-semibold mb-2">Acompanhamento</h3>
              <p className="text-blue-100 text-sm">Monitoramento dos resultados</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-focus-orange text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Pronto para Organizar sua Empresa?
          </h2>
          <p className="text-xl mb-8 text-red-100 max-w-2xl mx-auto">
            Não perca mais tempo com desorganização. Entre em contato e transforme sua empresa hoje mesmo!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:+5511123456789"
              className="bg-white text-focus-orange hover:bg-gray-100 px-8 py-4 rounded-lg text-lg font-semibold transition-colors inline-block"
            >
              📞 Ligue Agora
            </a>
            <a
              href="mailto:contato@focus.com.br"
              className="bg-transparent border-2 border-white hover:bg-white hover:text-focus-orange text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors inline-block"
            >
              ✉️ Solicite Orçamento
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FocusOrganiza;